// import yeti from "../yeti";

export default () => {
  // if (!yeti.isSlowInternet()) {
  //   const video = document.querySelector(".headslider__video > video");
  //   if (video) {
  //     video.play();
  //   }
  // }
}
